import { InitializationState } from '@tmx/core';
import { filter, pipe } from 'rxjs';

/**
 * Insert into pipe for InitializationState Observable to filter out any 'loading' state
 * @returns 'failed' or 'initialized' InitializationState
 * @example
 * const completedState$ = state$.pipe(
 *  filterOutLoadingState()
 * )
 */
export const filterOutLoadingState = () => {
  return pipe(
    filter(
      (state: InitializationState): state is 'failed' | 'initialized' =>
        state !== 'loading'
    )
  );
};
